<template>
    <modal-cadu close :width="740" v-model="valueData">
        <div slot="all" class="py-10 px-10">
            <div slot="header" class="primary1--text headline font-weight-bold">
                Pendência
            </div>
            <div slot="body">
                <v-row>
                    <v-col cols="12">
                        <div class="fontColor--text subtitle-2">
                            <div class="mb-2 inject-class" v-html="mensagem"/>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <validation-provider ref="provider" name="textArea" rules="required|max:200" mode="eager" v-slot="{ errors }">
                            <textarea-cadu
                                :errorMessage="errors[0]"
                                v-model="justificativa"
                                :colorText="$vuetify.theme.themes.light.fontColor1"
                                title="Justificativa:"
                                max="200"
                            />
                        </validation-provider>
                    </v-col>
                </v-row>
            </div>
            <div slot="footer" class="pt-4">
                <v-row align="center" justify="start" no-gutters>
                    <v-col cols="auto">
                        <button-cadu @click="$emit('input', false)" outline text="VOLTAR"/>
                    </v-col>
                    <v-row align="center" justify="end" no-gutters>
                        <v-col cols="auto">
                            <button-cadu @click="salvarJustificativa" text="SALVAR" />
                        </v-col>
                    </v-row>
                </v-row>
            </div>
        </div>
    </modal-cadu>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  components: {
    ValidationProvider
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mensagem: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      valueData: this.value,
      justificativa: ''
    }
  },
  methods: {
    async salvarJustificativa () {
      let validate = await this.$refs.provider.validate()
      if (validate.valid) {
        this.$emit('salvarPendencia', this.justificativa)
      }
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      if (!this.valueData) {
        this.justificativa = ''
        this.$emit('input', this.valueData)
      }
    }
  }
}
</script>

<style>

</style>
